import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { utils } from '@atlaskit/util-service-support';
import { generateHash } from '../../../utils/caching/common/key-generator';
import { refreshOnAccess } from '../../../utils/caching/persist-refresh';
var RELATIVE_URL = '/gateway/api/xpsearch-aggregator/configuration/v1';
var RELATIVE_3P_URL = '/gateway/api/third-party-configuration/connected-data-sources';
var _refreshOnAccess = refreshOnAccess({
    name: 'search-config'
  }),
  refreshOnAccessDecoratorSearch = _refreshOnAccess.refreshOnAccessDecorator;
export var SEARCH_3P_CONFIG = 'search-3p-config';
var _refreshOnAccess2 = refreshOnAccess({
    name: SEARCH_3P_CONFIG,
    expiration: 1000 * 60 * 5
  }),
  refreshOnAccessDecorator3pSearch = _refreshOnAccess2.refreshOnAccessDecorator;
/**
 * Sample response:
 * {
    "resources": [
        {
            "id": "ari:cloud:avp::site/DUMMY-158c8204-ff3b-47c2-adbb-a0906ccc722b",
            "baseUrl": "https://product-fabric.atlassian.net",
            "siteName": "product-fabric"
        },
      ]
    }
 */

export var getSearchConfig = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$absoluteUrl, absoluteUrl, cloudId, userId, url, options, key, supplier;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref$absoluteUrl = _ref.absoluteUrl, absoluteUrl = _ref$absoluteUrl === void 0 ? '' : _ref$absoluteUrl, cloudId = _ref.cloudId, userId = _ref.userId;
          url = absoluteUrl || RELATIVE_URL;
          options = {
            requestInit: {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            }
          };
          key = generateHash("1p|".concat(userId, "|").concat(cloudId));
          supplier = function supplier() {
            return utils.requestService({
              url: url
            }, options).then(function (data) {
              return {
                resources: data.resources.filter(function (resource) {
                  return cloudId ? resource.id.includes(cloudId) : true;
                }),
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
              };
            });
          };
          return _context.abrupt("return", refreshOnAccessDecoratorSearch(key.toString(), supplier));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSearchConfig(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Sample response:
 * [
      {
        "type": "ai-3p-connector:google-workspace",
        "location": "ari:third-party:google::site/DUMMY-0c418054-69d8-4a6c-bec6-8ef053070a36"
      }
    ]
 */

export var get3pSearchConfig = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var _ref3$absoluteUrl, absoluteUrl, cloudId, userId, baseUrl, url, options, key, supplier;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref3$absoluteUrl = _ref3.absoluteUrl, absoluteUrl = _ref3$absoluteUrl === void 0 ? '' : _ref3$absoluteUrl, cloudId = _ref3.cloudId, userId = _ref3.userId;
          baseUrl = absoluteUrl || RELATIVE_3P_URL;
          url = "".concat(baseUrl, "/").concat(cloudId);
          options = {
            requestInit: {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            }
          };
          key = generate3pHash(userId || '', cloudId || '');
          supplier = function supplier() {
            return utils.requestService({
              url: url
            }, options);
          };
          return _context2.abrupt("return", refreshOnAccessDecorator3pSearch(key.toString(), supplier, false));
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function get3pSearchConfig(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
export var generate3pHash = function generate3pHash(userId, cloudId) {
  return generateHash("3p|".concat(userId, "|").concat(cloudId));
};